// extracted by mini-css-extract-plugin
export var active = "_92-a";
export var activeIndicator = "_92-9";
export var disabled = "_92-b";
export var fullWidth = "_92-2";
export var lg = "_92-7";
export var md = "_92-6";
export var redoButtonTabGroup = "_92-0";
export var sm = "_92-5";
export var tabButton = "_92-4";
export var tabButtonsContainer = "_92-1";
export var themeDestructive = "_92-d";
export var themeNormal = "_92-c";
export var themeSuccess = "_92-e";
export var xl = "_92-8";
export var xs = "_92-3";